// Fetch helper com CSRF (o backend mantém a proteção; token vem da meta tag).

function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
}

export class ApiError extends Error {
  errors: string[]

  constructor(errors: string[], status: number) {
    super(`API error (${status})`)
    this.errors = errors
  }
}

async function parseErrors(response: Response): Promise<string[]> {
  try {
    const body = await response.json()
    if (Array.isArray(body.errors)) return body.errors
    if (body.error) return [body.error]
  } catch {
    // corpo não-JSON
  }
  return ["Algo deu errado. Tente novamente."]
}

export async function postJSON<T>(path: string, payload: unknown): Promise<T> {
  const response = await fetch(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken()
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok) throw new ApiError(await parseErrors(response), response.status)
  return response.json()
}

export async function getJSON<T>(path: string): Promise<T> {
  const response = await fetch(path, { headers: { "Accept": "application/json" } })
  if (!response.ok) throw new ApiError(await parseErrors(response), response.status)
  return response.json()
}
